module.exports = __webpack_public_path__ + "static/media/icon-line-finance.d0e1f3ca.svg";